module.exports = "https://static.wmbcdn.com/uniweb/images/c55f3b51d737698ad846e958a6d52f62.svg";